import { ReactElement, useRef, useState } from 'react';

import { ctxPopup } from '@/contexts/PopupContext';
import Loader from '@/components/common/Loader';
import { LoaderProps } from '@/types';

export default function Popups({ children }: { children: ReactElement }) {
  const [popupLoader, setPopupLoader] = useState<ReactElement | undefined>(undefined);
  const counter = useRef(0);

  // TODO ne lehessen secondary-t masikkal felulirni ?
  // TODO lehessen tobb notification is ??

  function showLoader(type?: LoaderProps) {
    if (counter.current === 0) {
      setPopupLoader(<Loader type={type} />);
    }
    counter.current++;
  }
  function hideLoader() {
    counter.current--;
    if (counter.current === 0) {
      setPopupLoader(undefined);
    }
  }

  return (
    <ctxPopup.Provider
      value={{
        setPopupLoader,
        showLoader,
        hideLoader,
        drawerMenuOpen: false,
      }}
    >
      {popupLoader}
      {children}
    </ctxPopup.Provider>
  );
}
